import { generateUUID } from '@thoughtspot/js-util';
import { BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import React, { useEffect, useRef } from 'react';
import { GlobalAlertContext } from './global-alert-context';
const useGlobalAlert = () => {
    const context = React.useContext(GlobalAlertContext);
    if (context === undefined || context === null) {
        throw new Error(`useGlobalAlert() hook must be used within a GlobalAlertContext Provider.
             If you are seeing this in a unit test, please wrap your component
             in a <GlobalAlertContextProvider>. (See data-sources.spec.tsx)`);
    }
    return context;
};
const Banner = (props) => {
    const { closeOnUnmount = true } = props;
    const alertId = useRef(generateUUID());
    const { updateBannerAlert } = useGlobalAlert();
    const latestProps = useRef(props);
    const onClose = () => {
        props?.onClose?.();
        updateBannerAlert(alertId.current, {
            isVisible: false,
            message: null,
            type: BannerAlertType.WARNING,
        });
    };
    useEffect(() => {
        updateBannerAlert(alertId.current, { ...props, onClose });
    }, [props.isVisible, props.message]);
    useEffect(() => {
        latestProps.current = props;
    }, [props]);
    useEffect(() => {
        return () => {
            if (closeOnUnmount && latestProps.current.isVisible) {
                updateBannerAlert(alertId.current, {
                    isVisible: false,
                    message: null,
                    type: BannerAlertType.WARNING,
                    onClose,
                });
            }
        };
    }, []);
    return null;
};
const Toast = (props) => {
    const alertId = useRef(generateUUID());
    const { updateToastAlert } = useGlobalAlert();
    useEffect(() => {
        updateToastAlert(alertId.current, props);
    }, [props.isVisible, props.message]);
    return null;
};
export const GlobalAlert = () => null;
GlobalAlert.Banner = Banner;
GlobalAlert.Toast = Toast;
//# sourceMappingURL=global-alert.js.map